module.exports = __webpack_public_path__ + "static/media/game-background-space-concepts.46ff1a19.jpg";